export const ADMIN_ONBOARDING_PENDING_KEY = 'famla_admin_onboarding_pending';
export const ADMIN_ONBOARDING_TARGET_KEY = 'famla_admin_onboarding_target';

export const startAdminOnboarding = () => {
    sessionStorage.setItem(ADMIN_ONBOARDING_PENDING_KEY, 'true');
    sessionStorage.removeItem(ADMIN_ONBOARDING_TARGET_KEY);
};

export const consumeAdminOnboardingTarget = (): string | null => {
    const target = sessionStorage.getItem(ADMIN_ONBOARDING_TARGET_KEY);
    sessionStorage.removeItem(ADMIN_ONBOARDING_TARGET_KEY);
    return target;
};
